import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Button, ButtonGroup, DropdownButton, Modal } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';

import { Receivable } from 'services/action';

import { currencyFormat, formatDate } from 'utilities/common';

const initialState = {
  showSend: false,
  dataSend: null,
};

const Outstanding = ({ data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const [{ showSend, dataSend }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, showSend: false, dataSend: null}));
  };

  const $sendEmail = async () => {
    const payload = {
      customer_id: dataSend?.customer?.id
    }
    const req = await Dispatch(Receivable.$emailWilltolate(payload));
    if (req?.message === 'success') {
      $handleClose()
    }
  }

  if (!data) {
    return (
        <div className="row">
            <div className="empty col-lg-12 truck">
              <div className="truck-wrapper">
                <div className="truck">
                  <div className="truck-container"></div>
                  <div className="glases"></div>
                  <div className="bonet"></div>
                  <div className="base"></div>
                  <div className="base-aux"></div>
                  <div className="wheel-back"></div>
                  <div className="wheel-front"></div>
                  <div className="smoke"></div>
                </div>
              </div>
              <p className="empty-title">Monitoring not found.</p>
            </div>
        </div>
    )
  }

  return (
    <div className='px-3'>
      <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
        Outstanding
      </div>


      <div className="table-responsive m-0 table-overflow border">
        <table
          className="table table-vcenter card-table datatable"
          width="100%"
        >
          <thead>
            <tr>
              <th
                className="text-start border-end"
                style={{ whiteSpace: 'initial'}}
              >
                Client
              </th>
              <th
                className="text-end border-end"
                style={{ whiteSpace: 'initial', width: '25%', }}
              >
                Nominal
              </th>
              <th
                className="text-center border-end"
                style={{ whiteSpace: 'initial', width: '20%', }}
              >
                Terakhir Kirim Email
              </th>
              <th
                className="border-end text-center"
                style={{ whiteSpace: 'initial', width: '8%' }}
              >
                &nbsp;
              </th>
            </tr>
          </thead>
          <tbody className="bg-white graph">
            {data?.map((d, i) => (
              <tr key={`${i}`}>
                <td className="border-end">
                  <div className="table-col">
                    <div className="text-ellipsis fw-semibold text-uppercase">
                      {d?.customer?.name}
                    </div>
                    <small className="info text-uppercase">
                      {d?.customer?.company_name}
                    </small>
                  </div>
                </td>
                <td style={{width: '25%'}} className="border-end text-end">
                  {currencyFormat(d?.nominal)}
                </td>
                <td style={{width: '20%'}} className="border-end text-center">
                  {formatDate(d?.outstanding_send_at, 'DD/MM/YYYY') || '-'}
                </td>
                <td style={{width: '8%'}} className="border-end text-center">
                  <DropdownButton
                    as={ButtonGroup}
                    variant="transparent"
                    size="md"
                    className="no-carret tbl-action"
                    title={<Fi.FiMoreVertical size={13} color="gray" />}
                  >
                    <Link
                      className="dropdown-item d-flex align-items-center"
                      role="button"
                      to={`/report/aging/${d?.customer?.id}?type=outstanding`}
                    >
                      <Fi.FiClipboard size={15} color="#202020" className="me-2" />
                      Detil
                    </Link>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      onClick={() =>
                        setState((prevState) => ({ ...prevState, showSend: true, dataSend: d }))
                      }
                    >
                      <Fi.FiSend size={15} color="#202020" className="me-2" />
                      Kirim Email
                    </button>
                  </DropdownButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* modal send email */}
      <Modal
        show={showSend}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Dokumen akan dikirimkan melalui email
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$sendEmail}
                disabled={StateForm?.loading}
              >
                Kirim
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

    </div>

  );
};

export default Outstanding;